import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Users, GraduationCap, GitMerge } from 'lucide-react';
export function Problem() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const problems = [{
    icon: <Users className="w-6 h-6 text-accent mb-4" data-id="element-108" />,
    title: 'Overstaffed Teams',
    desc: 'Paying for bodies in the room rather than brains on the problem.'
  }, {
    icon: <GraduationCap className="w-6 h-6 text-accent mb-4" data-id="element-109" />,
    title: 'Junior Analysts',
    desc: 'Recent graduates learning the ropes on your budget and timeline.'
  }, {
    icon: <GitMerge className="w-6 h-6 text-accent mb-4" data-id="element-110" />,
    title: 'Rigid Methodologies',
    desc: 'Prioritising firm-standard processes over bespoke, outcome-driven solutions.'
  }];
  return <section id="about" className="py-24 md:py-32 bg-secondary relative border-t border-border" data-id="element-111">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-112">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-113">
          <motion.div variants={itemVariants} className="mb-16 md:mb-24" data-id="element-114">
            <h2 className="text-xs text-accent tracking-[0.2em] uppercase mb-4" data-id="element-115">
              The Problem
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-text-light max-w-2xl leading-tight" data-id="element-116">
              Traditional consulting is broken.
            </h3>
            <p className="text-text-muted mt-6 text-lg max-w-xl" data-id="element-117">
              You pay premium fees for slow delivery, inflated costs, and
              strategies that often lack originality.
            </p>
          </motion.div>

          <motion.div variants={containerVariants} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-118">
            {problems.map((prob, idx) => <motion.div key={idx} variants={itemVariants} className="bg-primary border border-border p-8 hover:border-accent/50 transition-colors duration-300" data-id="element-119">
                {prob.icon}
                <h4 className="text-xl font-serif text-text-light mb-3" data-id="element-120">
                  {prob.title}
                </h4>
                <p className="text-text-muted text-sm leading-relaxed" data-id="element-121">
                  {prob.desc}
                </p>
              </motion.div>)}
          </motion.div>

          <motion.div variants={itemVariants} className="max-w-3xl border-l-2 border-accent pl-8 py-2" data-id="element-122">
            <p className="text-xl md:text-2xl font-serif text-text-light leading-relaxed italic" data-id="element-123">
              "At the same time, the world's sharpest business thinkers—top MBA
              candidates—are underutilised, sitting inside academic institutions
              instead of solving real-world problems."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}